// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ThZ_","notes":"Notes_notes__pbnDS"};